<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->
      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="5">
            <el-form-item label-width
                          prop="buyer_nick"
                          label="昵称">
              <el-input v-model="form.buyer_nick"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label-width
                          prop="points"
                          label="积分">
              <!-- <el-input v-model="form.points"></el-input> -->
              <number-range v-model="form.points" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label-width
                          prop="interaction_c"
                          label="互动次数">
              <!-- <el-input v-model="form.interaction_c"></el-input> -->
              <number-range v-model="form.interaction_c" />
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item label-width
                          prop="interaction_f"
                          label="首次互动时间">
              <!-- <el-input v-model="form.interaction_f"></el-input>/ -->
              <el-date-picker v-model="form.interaction_f"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width
                          prop="interaction_l"
                          label="最近互动时间">
              <!-- <el-input v-model="form.interaction_l"></el-input>
              -->
              <el-date-picker v-model="form.interaction_l"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="searchAreaStatus">
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 90%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <!-- <el-row>
        <el-col :span="12">
          <el-button @click="handleExport" type="primary" size="medium">导出</el-button>
          <el-button @click="handleImport" type="primary" size="medium">导入</el-button>
          <el-button @click="handleSearch" size="medium">搜索</el-button>
          <el-button @click="clearSearch" size="medium">重置</el-button>
        </el-col>
      </el-row>-->
      <action-line @action-line="handleActionLine"
                   :list="actionLineWithImport">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开"}}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="昵称"></el-table-column>
      <el-table-column prop="points"
                       align="center"
                       header-align="center"
                       label="积分"></el-table-column>
      <el-table-column prop="interaction_f"
                       align="center"
                       header-align="center"
                       label="首次互动时间"></el-table-column>
      <el-table-column prop="interaction_l"
                       align="center"
                       header-align="center"
                       label="最近互动时间"></el-table-column>
      <el-table-column prop="interaction_c"
                       align="center"
                       header-align="center"
                       label="互动次数"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'
import handleImport from '@/common/mixins/handle-import'

import ImportDialog from '@/base/importDialog'

import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
export default {
  mixins: [ActionLine, SearchMixin, handleExport, handleImport],
  components: {
    ImportDialog,
  },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/memberdata/index.vue